import teamReducer from "./reducers";

export default teamReducer;